/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useStateContext } from "../../../../contexts/ThemeContext";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as CheckOutline } from "../../../../assets/settingPage/tick-circle-outline.svg";
import { ReactComponent as CheckFill } from "../../../../assets/settingPage/tick-circle.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/settingPage/received.svg";
import { ReactComponent as Previous } from "../../../../assets/settingPage/arrow-left.svg";
import { ReactComponent as PreviousDark } from "../../../../assets/settingPage/arrow-left-dark.svg";
import { ReactComponent as Next } from "../../../../assets/settingPage/arrow-right.svg";
import { ReactComponent as NextDark } from "../../../../assets/settingPage/arrow-right-dark.svg";

import Pagination from "../../../../utils/pagination/Pagination";
import useLocales from "../../../../hooks/useLocales";
import { useDispatch, useSelector } from "react-redux";
import { gettingPaymentsPalnsList } from "../../../../redux/slices/paymentStripes/paymentStripesSlice";
import useSettings from "../../../../hooks/useSettings";
import MobileBottomLogoutBtn from "../../../../components/dashboard/MobileBottomLogoutBtn";
import { Helmet } from "react-helmet";
import OgImage from "../../../../assets/landingPages/homePage/Hero.png";

import {
  getPaymentsByUserId,
  resetgetPaymentsByUserId,
} from "../../../../redux/slices/paymentStripes/paymentStripesSlice";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";

const baseUrl = process.env.REACT_APP_API_URL;

const Billings = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveSettingSubNav } = useStateContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredArray, setFilteredArray] = useState([]);
  const [allInvoices, setAllInvoices] = useState([]);
  const [allCardsInfo, setAllCardsInfo] = useState([]);

  useEffect(() => {
    setActiveSettingSubNav("billings");
    return () => {
      setActiveSettingSubNav(null);
    };
  }, []);

  useEffect(() => {
    dispatch(getPaymentsByUserId()).then(() => {
      resetgetPaymentsByUserId();
    });
  }, []);

  const {
    getPaymentsByUserid,
    getPaymentsByUserIdError,
    getPaymentsByUserIdLoading,
  } = useSelector((state) => state?.paymentStripes);

  useEffect(() => {
    const newArray = getPaymentsByUserid?.getPaymentsDetails?.slice(
      (currentPage - 1) * 5,
      currentPage * 5
    );

    setFilteredArray(newArray);
    if (getPaymentsByUserIdError) {
      navigate("/500");
    }
  }, [
    getPaymentsByUserid?.getPaymentsDetails,
    currentPage,
    allCardsInfo,
    getPaymentsByUserIdError,
  ]);

  const [plans, setPlans] = useState();

  const getPaymentStripeData = useSelector(
    (state) => state?.paymentStripes?.getPaymentsPlansList
  );

  useEffect(() => {
    gettingPaymentsPlans();
  }, []);

  const gettingPaymentsPlans = () => {
    dispatch(gettingPaymentsPalnsList());
  };

  useEffect(() => {
    if (getPaymentStripeData?.status === "success") {
      setAllCardsInfo(getPaymentStripeData.result);
      setPlans(
        getPaymentStripeData.result?.filter(
          (plan) =>
            plan.name === "Free Plan" || plan.name === "Premium Plan (Paid)"
        )
      );
    }
  }, [getPaymentStripeData?.status === "success"]);

  const getAllStripeInvoices = async (code) => {
    const path = `/api/user/getAllStripeInvoices`;
    const url = baseUrl + path;
    const response = await axios.get(url);
    setAllInvoices(response.data.invoices?.data);
    return response.data;
  };
  useEffect(() => {
    getAllStripeInvoices();
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Billing Setting | Bil.Bio</title>
        <meta property="og:title" content="Billing Setting | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="mt-10 mb-10 md:hidden ">
        <Link className="flex items-center gap-3" to={"/dashboard/setting"}>
          <div className="flex items-center justify-center ">
            {darkMode ? (
              <LeftArrowDark
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            {translate("addBlock.billings")}
          </h6>
        </Link>
      </div>
      <div className="w-full bg-white dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[90px]">
        <form>
          <div className="min-h-[calc(100vh_-_200px)]">
            <div>
              <h1 className="text-body_copy2_black lg:text-custom_h6  dark:text-color_v1_dark">
                {translate("addBlock.billings")}
              </h1>
              <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-font_dark_color">
                {translate("addBlock.choose_plan_description")}.
              </p>
              <hr className="mt-4 md:mt-5 dark:border-color_dark" />
              <div>
                <div className="flex flex-col xl:flex-row gap-6 md:gap-[30px] items-center justify-items-center mt-[30px] dark:bg-dark-secondary">
                  {plans?.map((item, i) => {
                    return item?.name === "Free Plan" ? (
                      <div
                        key={i}
                        className={`${
                          darkMode ? "" : "shadow-box_shadow_1"
                        } dark:bg-dark-primary dark:border-border_transparent border border-light_bg_v1 w-full flex flex-col gap-[25px] p-5 lg:p-[25px] rounded-xl bg-white max-w-[279px] min-w-[218px] smm:max-w-[327px] smm:min-w-[279px] lg:min-w-[327px]`}
                      >
                        <div>
                          <div className="text-body_copy2_black text-body_copy1_color dark:text-color_v1_dark">
                            {/* {item?.name} */}
                            {translate("front_end_pages.pricing.free_plan")}
                          </div>
                          <h4 className="text-custom_h4 mt-2.5 text-heading_color dark:text-color_v1_dark">
                            {item?.annual_price}
                          </h4>

                          <div className="text-dark_bg_v5 text-small3 mt-[15px] dark:text-font_dark_color">
                            {item?.description}
                          </div>
                        </div>

                        <div className="flex flex-col gap-3">
                          <div className="flex gap-1.5 items-center text-small3 text-body_copy1_color dark:text-color_v1_dark">
                            <CheckOutline />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.unlimited_biolink_pages"
                              )}
                            </p>
                          </div>
                          <div className="flex gap-1.5 items-center text-small3 text-body_copy1_color dark:text-color_v1_dark">
                            <CheckOutline />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.unlimited_biolink_blocks"
                              )}
                            </p>
                          </div>
                          <div className="flex gap-1.5 items-center text-small3 text-body_copy1_color dark:text-color_v1_dark">
                            <CheckOutline />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.bio_pages"
                              )}
                            </p>
                          </div>
                          <div className="flex gap-1.5 items-center text-small3 text-body_copy1_color dark:text-color_v1_dark">
                            <CheckOutline />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.seo_feature"
                              )}
                            </p>
                          </div>
                          <div className="flex gap-1.5 items-center text-small3 text-body_copy1_color dark:text-color_v1_dark">
                            <CheckOutline />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.brandings"
                              )}
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            navigate(
                              `/pricing/payment/PaymentDetailsFormPage/annual/${item?.product_id?._id}`
                            );
                          }}
                          className="w-full text-center p-[6px] px-[22px] text-white rounded-full bg-gradient-to-br from-[#f8765c] to-[#f7554b] text-small3_b"
                        >
                          {translate("choose_plan_cap")}
                        </button>
                      </div>
                    ) : null;
                  })}
                  {plans?.map((item, i) => {
                    return item?.name === "Premium Plan (Paid)" ? (
                      <div
                        key={i}
                        className={`${
                          darkMode ? "" : "shadow-box_shadow_1"
                        } w-full flex flex-col gap-[25px] p-5 lg:p-[25px] rounded-xl bg-gradient-to-br from-[#f8765c] to-[#f7554b] text-white max-w-[279px] min-w-[218px] smm:max-w-[327px] smm:min-w-[279px] lg:min-w-[327px]`}
                      >
                        <div>
                          <div className="text-white text-body_copy2">
                            {/* {item?.name} */}
                            {translate(
                              "front_end_pages.pricing.premium_plan_paid"
                            )}
                          </div>
                          <div className="flex gap-2 mt-2.5 items-center">
                            <div className="text-custom_h4">
                              {item?.annual_price}
                            </div>
                          </div>
                          <div className="text-white text-small3 mt-[15px]">
                            {item?.description}
                          </div>
                        </div>

                        <div className="flex flex-col gap-3">
                          <div className="flex items-center gap-2 text-white text-small3">
                            <CheckFill />
                            <p>
                              {" "}
                              {translate(
                                "front_end_pages.home_page.pricing_section.unlimited_biolink_pages"
                              )}
                            </p>
                          </div>
                          <div className="flex items-center gap-2 text-white text-small3">
                            <CheckFill />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.unlimited_biolink_blocks"
                              )}
                            </p>
                          </div>
                          <div className="flex items-center gap-2 text-white text-small3">
                            <CheckFill />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.bio_pages"
                              )}
                            </p>
                          </div>
                          <div className="flex items-center gap-2 text-white text-small3">
                            <CheckFill />
                            <p>
                              {" "}
                              {translate(
                                "front_end_pages.home_page.pricing_section.seo_feature"
                              )}
                            </p>
                          </div>
                          <div className="flex items-center gap-2 text-white text-small3">
                            <CheckFill />
                            <p>
                              {translate(
                                "front_end_pages.home_page.pricing_section.brandings"
                              )}
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            navigate(
                              `/pricing/payment/PaymentDetailsFormPage/annual/${item?.product_id?._id}`
                            );
                          }}
                          className="w-full text-center p-[6px] px-[22px] text-heading_color  rounded-full bg-white text-small3_b"
                        >
                          {translate("choose_plan_cap")}
                        </button>
                      </div>
                    ) : null;
                  })}
                </div>
                <hr className="hidden mt-10 md:block dark:border-color_dark" />
                <div className="hidden lg:block">
                  <p className="text-body_copy1_b mt-[30px] ml-5 dark:text-color_v1_dark">
                    {translate("addBlock.billing_history")}
                  </p>

                  <div className="relative mt-5 overflow-x-auto ">
                    <table className="w-full text-sm text-gray-500 dark:text-color_v1_dark text-start ">
                      <thead className="text-small1 text-dark_bg_v5  dark:text-color_v1_dark capitalize border-y border-[#EEE] dark:border-color_dark">
                        <tr>
                          <td className="ps-5 pt-[18px] pb-[17px] min-w-[340px]">
                            {translate("descriptions.user")}
                          </td>
                          <td className="pt-[18px] pb-[17px] min-w-[150px] dark:text-color_v1_dark">
                            {translate("descriptions.plan")}
                          </td>
                          <td className="pt-[18px] pb-[17px] min-w-[170px] dark:text-color_v1_dark">
                            {translate("addBlock.date_joined")}
                          </td>
                          <td className="pt-[18px] pb-[17px] min-w-[170px] dark:text-color_v1_dark">
                            {translate("addBlock.last_activity")}
                          </td>
                          <td className="pe-5 pt-[18px] pb-[17px] min-w-[100px] text-center dark:text-color_v1_dark">
                            {translate("planss.action")}
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {!getPaymentsByUserIdLoading &&
                          filteredArray?.map((item, i) => {
                            const invoiceInfo = allInvoices?.find(
                              (invoice) =>
                                invoice.id === item?.strip_latest_invoice
                            );

                            return (
                              <tr
                                key={i}
                                className="bg-white border-b text-body_copy1_color dark:border-color_dark dark:bg-dark-secondary"
                              >
                                <td className="ps-5 pt-[33px] pb-[26px] whitespace-nowrap text-body_copy2 w-[410px] dark:text-color_v1_dark">
                                  Invoice {item?.invoiceNumber}
                                </td>
                                <td className=" pt-[33px] pb-[26px] text-small2_b text-main_color pe-3 whitespace-nowrap">
                                  {item?.product_name === "Free Plan"
                                    ? translate(
                                        "front_end_pages.pricing.free_plan"
                                      )
                                    : item?.product_name ===
                                      "Premium Plan (Paid)"
                                    ? translate(
                                        "front_end_pages.pricing.premium_plan_paid"
                                      )
                                    : item?.product_name}
                                </td>
                                <td className=" pt-[33px] pb-[26px] text-small2 dark:text-color_v1_dark">
                                  {moment(item?.createdAt).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                                <td className=" pt-[33px] pb-[26px] text-small2 dark:text-color_v1_dark">
                                  {moment(item?.updatedAt).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                                <td className="pe-5 py-[25px] flex gap-5 justify-center items-center w-[100px]">
                                  {invoiceInfo ? (
                                    <a
                                      href={invoiceInfo?.invoice_pdf}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <DownloadIcon className="cursor-pointer stroke-[#444444] dark:stroke-[#FFFFFF]" />
                                    </a>
                                  ) : (
                                    <DownloadIcon
                                      className="cursor-pointer stroke-[#444444] dark:stroke-[#FFFFFF]"
                                      onClick={() => {
                                        toast.error("Invoice Not Found");
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        <tr className="bg-white dark:bg-dark-secondary">
                          <td colSpan={5} className="w-full px-0 pt-10 pb-5">
                            <div className="w-full">
                              <Pagination
                                previousLabel={
                                  <button className="flex items-center gap-3 text-small2_b text-body_copy1_color dark:text-color_v1_dark">
                                    {darkMode ? (
                                      <PreviousDark
                                        className={`${
                                          themeDirection === "rtl"
                                            ? "transform -scale-x-100"
                                            : ""
                                        }`}
                                      />
                                    ) : (
                                      <Previous
                                        className={`${
                                          themeDirection === "rtl"
                                            ? "transform -scale-x-100"
                                            : ""
                                        }`}
                                      />
                                    )}
                                    {/* Previous */}
                                    {translate("cms.previous")}
                                  </button>
                                }
                                nextLabel={
                                  <button className="flex items-center gap-3 text-small2_b text-body_copy1_color dark:text-color_v1_dark">
                                    {/* Next */}
                                    {translate("cms.next")}
                                    {darkMode ? (
                                      <NextDark
                                        className={`${
                                          themeDirection === "rtl"
                                            ? "transform -scale-x-100"
                                            : ""
                                        }`}
                                      />
                                    ) : (
                                      <Next
                                        className={`${
                                          themeDirection === "rtl"
                                            ? "transform -scale-x-100"
                                            : ""
                                        }`}
                                      />
                                    )}
                                  </button>
                                }
                                breakLabel={"..."}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                containerClassName={
                                  "items-center flex justify-between w-full pagination"
                                }
                                subContainerClassName={
                                  "pages pagination flex items-center"
                                }
                                pageClassName={
                                  "page-link cursor-pointer text-small2_b text-dark_bg_v5 h-[21px] w-[41px] hover:text-dark_bg_v3 flex justify-center items-center text-center"
                                }
                                pageLinkClassName="h-full w-full flex justify-center items-center text-center "
                                previousLinkClassName={
                                  "page-link cursor-pointer"
                                }
                                disabledLinkClassName={
                                  "text-gray-400 opacity-50"
                                }
                                nextLinkClassName={"page-link cursor-pointer"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"p-0 pt-0 pr-0 pb-0 pl-0"}
                                activeLinkClassName={
                                  "dark:text-color_v1_dark active text-small2_b text-dark_bg_v1 h-full w-full hover:text-dark_bg_v3 flex justify-center items-center text-center"
                                }
                                currentPage={currentPage}
                                totalCount={
                                  getPaymentsByUserid?.getPaymentsDetails
                                    ?.length || 0
                                }
                                pageSize={5}
                                onPageChange={(page) => setCurrentPage(page)}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="lg:hidden">
        <p className="mt-10 ml-5 uppercase lg:text-body_copy1_b text-body_copy2_black dark:text-color_v1_dark">
          {/* BILLING HISTORY */}
          {translate("addBlock.billing_history")}
        </p>
        <div className="w-full mt-5 bg-white dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-5 lg:p-[50px] lg:mb-[90px]">
          <div>
            <div className="relative w-full overflow-x-auto">
              <table className="w-full text-start">
                <thead className="text-small1 text-dark_bg_v5 dark:text-color_v1_dark capitalize border-b border-[#EEE] dark:border-color_dark">
                  <tr>
                    <td className="ps-5 pt-[0px] pb-[17px] min-w-[340px] mr-[70px] dark:text-color_v1_dark">
                      {/* User */}
                      {translate("descriptions.user")}
                    </td>
                    <td className="pt-[0px] pb-[17px] min-w-[150px] mr-[70px] dark:text-color_v1_dark">
                      {/* Plan */}
                      {translate("descriptions.plan")}
                    </td>
                    <td className="pt-[0px] pb-[17px] min-w-[170px] whitespace-nowrap mr-[70px] dark:text-color_v1_dark">
                      {/* Date joined */}
                      {translate("addBlock.date_joined")}
                    </td>
                    <td className="pt-[0px] pb-[17px] min-w-[170px] whitespace-nowrap mr-[70px] dark:text-color_v1_dark">
                      {/* Last activity */}
                      {translate("addBlock.last_activity")}
                    </td>
                    <td className="pe-2 pt-[0px] pb-[17px] min-w-[100px] text-center mr-[70px] dark:text-color_v1_dark">
                      {/* Action */}
                      {translate("planss.action")}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {!getPaymentsByUserIdLoading &&
                    filteredArray?.map((item, i) => {
                      const invoiceInfo = allInvoices?.find(
                        (invoice) => invoice.id === item?.strip_latest_invoice
                      );
                      return (
                        <tr
                          key={i}
                          className="bg-white border-b  text-body_copy1_color dark:border-color_dark dark:bg-dark-secondary"
                        >
                          <td className="ps-5 pt-[33px] pb-[26px] whitespace-nowrap text-body_copy2 min-w-[340px] dark:text-color_v1_dark">
                            Invoice {item?.invoiceNumber}
                          </td>
                          <td className=" pt-[33px] pb-[26px] text-small2_b text-main_color pe-3 whitespace-nowrap">
                            {/* {item?.product_name} */}
                            {item?.product_name === "Free Plan"
                              ? translate("front_end_pages.pricing.free_plan")
                              : item?.product_name === "Premium Plan (Paid)"
                              ? translate(
                                  "front_end_pages.pricing.premium_plan_paid"
                                )
                              : item?.product_name}
                          </td>
                          <td className=" pt-[33px] pb-[26px] text-small2 whitespace-nowrap dark:text-color_v1_dark">
                            {moment(item?.createdAt).format("DD MMM YYYY")}
                          </td>
                          <td className=" pt-[33px] pb-[26px] text-small2 whitespace-nowrap dark:text-color_v1_dark">
                            {moment(item?.updatedAt).format("DD MMM YYYY")}
                          </td>
                          <td className="pe-2 py-[25px] flex gap-5 items-center justify-center w-[100px]">
                            {invoiceInfo ? (
                              <a
                                href={invoiceInfo?.invoice_pdf}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <DownloadIcon className="cursor-pointer stroke-[#444444] dark:stroke-[#FFFFFF]" />
                              </a>
                            ) : (
                              <DownloadIcon
                                className="cursor-pointer stroke-[#444444] dark:stroke-[#FFFFFF]"
                                onClick={() => {
                                  toast.error("Invoice Not Found");
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="block mt-5 lg:hidden">
        <Pagination
          previousLabel={
            <button className="flex items-center gap-3 text-small2_b text-body_copy1_color dark:text-color_v1_dark">
              {darkMode ? (
                <PreviousDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <Previous
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
              {/* Previous */}
              {translate("cms.previous")}
            </button>
          }
          nextLabel={
            <button className="flex items-center gap-3 text-small2_b text-body_copy1_color dark:text-color_v1_dark">
              {/* Next */}
              {translate("cms.next")}
              {darkMode ? (
                <NextDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <Next
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </button>
          }
          breakLabel={"..."}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          containerClassName={"items-center flex justify-between pagination"}
          subContainerClassName={"pages pagination flex items-center"}
          pageClassName={
            "page-link cursor-pointer text-small2_b text-dark_bg_v5 h-[9px] w-[21px] md:h-[21px] lg:w-[41px] hover:text-dark_bg_v3 flex justify-center items-center text-center"
          }
          pageLinkClassName="h-full w-full flex justify-center items-center text-center "
          previousLinkClassName={"page-link cursor-pointer"}
          disabledLinkClassName={"text-gray-400 opacity-50"}
          nextLinkClassName={"page-link cursor-pointer"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"p-0 pt-0 pr-0 pb-0 pl-0"}
          activeLinkClassName={
            "dark:text-color_v1_dark active text-small2_b text-dark_bg_v1 h-full w-full hover:text-dark_bg_v3 flex justify-center items-center text-center"
          }
          currentPage={currentPage}
          totalCount={getPaymentsByUserid?.getPaymentsDetails?.length || 0}
          pageSize={5}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
      <MobileBottomLogoutBtn />
    </>
  );
};

export default Billings;
